import React, {useEffect, useState} from 'react';
// MATERIAL UI
import { ButtonBase, ButtonGroup, Grid, Icon, IconButton, Typography, } from '@material-ui/core/';
import {Cancel, Delete, HighlightOff, PersonAdd, Save } from '@material-ui/icons';
// REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
// COMPONENTS
import BotonPersonalizado from 'components/BotonNormal'
import { useStyles } from "./style";
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import DialogLoadingMessage from 'components/LoadingMessage/index'
import { functions } from 'constants/index';
import Customdialog from 'components/CustomDialog';
import allActions from 'store/actions';
import { useSelector, useDispatch } from 'react-redux'
import Title from 'components/TitleWithIcon';
import { useHistory } from "react-router-dom";

function ComponenteDescargarLaConstanciaDeEmpadronamiento(props) {
    let history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [mensaje, setMensaje] = useState({loading: false, title:''});
    const [open, setOpen] = useState(props.idSoliciutudDelegacionProcesado.open)

    const DescargarConstancia = async () => {
        setMensaje({loading: true, title: 'Descargando constancia de empadronamiento ...'})
        var datos = {document: "constancia", id: props.idSoliciutudDelegacionProcesado.idSolicitud}
        try{            
            let response = await ApiServices.solicitudesDeEmpadronamiento.openFile(datos);
            if(response.error){
                showMessagePersonalizedPosition('error','¡Advertencia!', response.error.message,'center')
            }else {  
                functions.downloadPDFFromStringBase64(response.data.base64, "Constancia de Empadronamiento.pdf");        
            } 
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
        }         
        setMensaje({loading: false, title: ''})
    } 
    const CerrarDialogoParaDescargarConstancia = () => {
        dispatch(allActions.setDatosSolicitudExtranjero(''));
        dispatch(allActions.idSolicitudDelegacionProcesado({open: false, idSolicitud: ''}))
        setOpen(false)
        history.push("/generarSolicitudDeDelegacion",{})
    } 

    
    return (
        <div id="scroller" className={classes.root}>
                <DialogLoadingMessage open={mensaje.loading} title={mensaje.title}/>
                <Customdialog
                    open={open}
                    fullScreen={true}
                    showToolbar={false}
                    closeModal={CerrarDialogoParaDescargarConstancia}
                    // titleToolbar={'Descargar Constancia de empadronamiento'}                
                >
                    <Grid container style={{backgroundColor: 'white', height: '100%'}}>
                        <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                            <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                <h1 className={classes.h1} variant="h5" color="initial">Descargar Constancia de Empadronamiento</h1>   <br/><br/>
                            </Grid>
                            <Grid item xs={12} container direction="row" justify="center" alignItems="center" style={{height: '85%'}}>
                                {
                                    props.idSoliciutudDelegacionProcesado?.base64 ? (
                                        <iframe src={props.idSoliciutudDelegacionProcesado.base64} width="100%" height="100%" frameborder="0" allowfullscreen />
                                    ):(
                                        <div style={{fontSize: '1.7rem'}}>
                                            No se encontró ninguna constancia, por favor intente generar la constancia de emergencia. Si esto no le genera la constancia, comunicarse con soporte técnico del sistema para darle seguimiento al caso.
                                        </div>                            
                                    )
                                }
                            </Grid>                            
                            {
                                props.idSoliciutudDelegacionProcesado?.base64 ? (
                                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                        <BotonPersonalizado title={"Descargar Constancia"} botonAceptar={true} function={DescargarConstancia}/>
                                        <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={CerrarDialogoParaDescargarConstancia}/>
                                    </Grid>            
                                ):(
                                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                        <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={CerrarDialogoParaDescargarConstancia}/>                                        
                                    </Grid>            
                                )
                            }                                                                
                        </Grid>           
                    </Grid>
                </ Customdialog> 
        </div>
    );
}
export default connect(mapStateToProps)(ComponenteDescargarLaConstanciaDeEmpadronamiento);